import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { SquaredTickIcon } from "../../../../ui/icons/SquaredTickIcon"
import { useEffect, useState } from "react"
import { GetAllUpRows, resetGetAllStatus, resetUpdateStatus } from "./slice"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { NotUPResponseDataDTO } from "./dataService/dto"
import { NotUpPopupEdit } from "./editPopup"


export function UnitaProduttiveList() {
    const dispatch = useAppDispatch()
    const upState = useAppSelector(state => state.notificationUp)
    const [showEditPopup, setShowEditPopup] = useState<boolean>(false)
    const [upToEdit, setUpToEdit] = useState<NotUPResponseDataDTO | null>(null)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const notificationState = useAppSelector(state => state.notification)
    useEffect(() => {
        dispatch(GetAllUpRows({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
    }, [])

    useEffect(() => {
        if (upState.getAllUpRowsStatus === 'successfully') {
            dispatch(resetGetAllStatus())
        }
    }, [upState.getAllUpRowsStatus])

    useEffect(() => {
        if (upState.UpdateUpStatus === 'successfully') {
            setShowSuccess(true)
            setShowEditPopup(false)
            dispatch(GetAllUpRows({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500);
            dispatch(resetUpdateStatus())
        }
    }, [upState.UpdateUpStatus])

    return (
        <>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div style={{ padding: '24px' }}>

                <table id="users-table" className="w-[100%]">
                    <thead className="h-[52px] uppercase">
                        <tr>
                            <th style={{ borderTopLeftRadius: '8px' }}></th>
                            <th className="width-[130px]">Progressivo UP</th>
                            <th className="width-[20%]">Attività</th>
                            <th className="width-[100px]">Tipo</th>
                            <th className="width-[130px]">Belfiore</th>
                            <th className="width-[130px%]">Comune</th>
                            <th className="width-[130px]">CAP</th>
                            <th className="width-[130px]">Indirizzo</th>
                            <th className="width-[130px]">Recapiti</th>
                            <th className="width-[130px]">C.F. Rappresentante Legale</th>

                        </tr>
                    </thead>
                    <tbody>
                        {
                            upState.GetAllUpRowsResponse?.data.map((up, index) =>
                                <tr
                                    key={index}
                                    style={{
                                        color: '#4D797F',
                                        background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                    }}
                                >
                                    <td>
                                        <div style={{ display: 'flex', gap: '6px' }}>
                                            <button onClick={() => {
                                                setUpToEdit(up)
                                                setShowEditPopup(true)
                                            }}>
                                                <SquaredTickIcon />
                                            </button>
                                        </div>
                                    </td>
                                    <td>{up.productiveUnitNumber}</td>
                                    <td>{up.activity}</td>
                                    <td>{up.type}</td>
                                    <td>{up.cadastralCode}</td>
                                    <td>{up.city}</td>
                                    <td>{up.zipCode}</td>
                                    <td>{up.address}</td>
                                    <td>{up.contact}</td>
                                    <td>{up.legalRepresentativeFiscalCode}</td>
                                </tr>
                            )}
                    </tbody>
                </table>
                {
                    (showEditPopup && upToEdit) &&
                    <PopupForm title={`Modifica Unità Produttiva`} headerGreen close={() => setShowEditPopup(false)}>
                        <NotUpPopupEdit upSelected={upToEdit} close={() => setShowEditPopup(false)}></NotUpPopupEdit>
                    </PopupForm>
                }
            </div>
        </>
    )
}